<div #popover class="toast-popover" popover="manual">
  @if (visible()) {
    <div
      class="toast"
      [class.toast-leaving]="dismissing()"
      [class.toast--error]="type() === 'error'"
      [style.bottom]="offsetY()"
      [style.left]="centerX()"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <span class="toast-text">{{ text() }}</span>
      @if (isDismissable()) {
        <button
          type="button"
          class="toast-dismiss"
          (click)="dismiss()"
          aria-label="Dismiss notification"
          title="Dismiss notification"
        >
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">close</mat-icon>
        </button>
      }
    </div>
  }
</div>